import { SearchIconV2 } from '@/shared/ui/assets';
import { DEVICE } from '@/shared/config';
import { CustomSelect, CustomInput } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import type { SearchDeviceProps } from './searchDevice.types';
import { useSearchDevice } from './useSearchDevice';
import './searchDevice.scss';

/**
 * Search controls filtering devices by model and device id. Pulls the state and change handler from its hook, rendering a model select over All models, Bioflux, Biocore and Biocore Pro plus a numeric device id input with a search icon and a clear button.
 *
 * @param props - Search props forwarded to the device search hook.
 * @returns The device search controls element.
 */
const SearchDevice = (props: SearchDeviceProps) => {
  const { state, onChange } = useSearchDevice(props);

  return (
    <div className="search-options">
      <CustomSelect
        id="device-model-select"
        style={{ minWidth: 120 }}
        name="model"
        options={_.map(
          ['All models', DEVICE.BIOFLUX, DEVICE.BIOCORE, DEVICE.BIOCORE_PRO],
          (item) => ({
            label: item,
            value: item,
          }),
        )}
        value={state.model}
        onChange={onChange}
        size="middle"
        showSearch
        allowClear={false}
        placement="bottomRight"
        popupMatchSelectWidth={false}
        aria-label={t`Model`}
      />
      <CustomInput
        id="device-search-input"
        aria-label={t`Search by Device ID`}
        style={{ width: 300 }}
        name="searchValue"
        onChange={onChange}
        placeholder={t`Search by Device ID`}
        size="middle"
        type="number"
        value={state.searchValue}
        suffix={<img src={SearchIconV2} alt="Search Icon" />}
        allowClear
      />
    </div>
  );
};

export default SearchDevice;
